import * as React from 'react';
import { Tooltip } from 'antd';
import { localizedString } from '@locale/index';

export interface DelPopProps {
  icon?: JSX.Element;
}
export interface DelPopState { }
export class DelPop extends React.PureComponent<DelPopProps, DelPopState> {
  render() {
    const props = this.props;

    return (
      <span
        className="del-conflict-icon"
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          e.stopPropagation();
          e.preventDefault();

          return false;
        }}
      >
        <Tooltip title={localizedString('version_master_deleted')}>
          {props.icon ? (
            props.icon
          ) : (
            <i
              style={{ color: '#FE2727' }}
              className="iconfont del-conflict-icon icon-exclamationdelete_ic1"
            />
          )}

          {props.children}
        </Tooltip>
      </span>
    );
  }
}
